import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-kqgl_ccsq",
  "use": "icon-kqgl_ccsq-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-kqgl_ccsq\"><path d=\"M322 297h380v60H322zM322 407h380v60H322zM322 517h240v60H322z\" fill=\"#409eff\" p-id=\"6733\" /><path d=\"M192 162v700h300v-60H252V222h520v175h60V162z\" fill=\"#409eff\" p-id=\"6734\" /><path d=\"M590.024 780.954l190-329.08 51.96 30-190 329.08zM634.135 825.038l-51.962-30L558.154 862h40z\" fill=\"#409eff\" p-id=\"6735\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol